import { useState } from 'react';
import BuyCreditsModal from './BuyCreditsModal';
import Biling from '../popup/biling';
import { getToken } from '../../function/token';
import domain from '../../../reusecomponent/domain';
import { ErrorToastContainer, SuccessToastContainer } from '../../function/CustomFunction';
import Preloader from '../preloader';
import Razorpay from '../biling/razorpay';
import { useSelector } from 'react-redux';

export default function PurchaseCredits() {
  const [open, setOpen] = useState(false);
  const [visible,setvisible] = useState(false);
  const [loder, setLoder ] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const userServices = useSelector((state)=> state.serviceStore.value);

  const [bilininformation, setBilininformation] = useState({
    amount: 0,
    havegst: '',
    gstnumber: '',
    validated: null,
  });

  const handlePurchase = async () => {

    setvisible(false);
    setLoder(true);
    try {
      const access_token = getToken();
      const myHeaders = new Headers();
      myHeaders.append('Authorization', `Bearer ${access_token}`);
      myHeaders.append('Content-Type', 'application/json');
      let payload = {};
      if(bilininformation.havegst === 'Yes' && bilininformation.validated === true){
        payload = { 
          amount: parseInt(bilininformation.amount, 10),
          gst_number: bilininformation.gstnumber
        };
      }else{
        payload = { amount: parseInt(bilininformation.amount, 10) };
      }

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(payload),
      };
      const res = await fetch(`${domain()}/order/wallettopup`, requestOptions);
      const result = await res.json();
      if (result.status && result.data) {
        let data = JSON.parse(atob(result.data));
        setPaymentInfo(data);
      } else {
        ErrorToastContainer(result.message || 'Payment initiation failed');
      }
    } catch (e) {
      ErrorToastContainer('Payment initiation error');
    }finally {
      setLoder(false);
      setBilininformation({
        amount: 0,
        havegst: '',
        gstnumber: '',
        validated: null,
      });
    }
  }

  const handlePaymentStatus = async () => {
    try {
      setLoder(true)
      const access_token = getToken();
      const myHeaders = new Headers();
      myHeaders.append('Authorization', `Bearer ${access_token}`);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
      };
      // Use order_id from paymentInfo
      const orderId = paymentInfo?.order_id;
      const res = await fetch(`${domain()}/order-status/wallettopup/${btoa(orderId)}`, requestOptions);
      const result = await res.json();
      if (result.status) {
        let finaldata = atob(result.data);
        finaldata = JSON.parse(finaldata);
        if (finaldata.status === '1') {
          SuccessToastContainer(finaldata.message || 'Credits added successfully!');
        } else if (finaldata.status === '0') {
          ErrorToastContainer(finaldata.message || 'Payment failed.');
        } else {
          ErrorToastContainer('Payment pending. Please check later.');
        }
      } else {
        ErrorToastContainer(result.message || 'Payment verification failed.');
      }
    } catch (e) {
      ErrorToastContainer('Internal Server Error');
    }finally {
      setLoder(false);
      setPaymentInfo(null);
    }
  };

  return (
    <>
      {visible && (<Biling componentvisible={setvisible} payNow={handlePurchase} bilininformation={bilininformation} setBilininformation1={setBilininformation} setPreloader={setLoder}/>)}
      <Razorpay paymentInfo={paymentInfo} handlePaymentStatus={handlePaymentStatus}/>
      <Preloader action={loder} />
      <div className="purchase-credits-card card border-0 shadow-sm" style={{
        background: '#fff',
        borderRadius: '16px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
        padding: '20px 24px',
        marginTop: 20,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}>
        <div style={{ fontSize: 13.5, fontWeight: 600, color: '#64748b', marginBottom: 8 }}>Purchase Credits</div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 20, fontWeight: 700, color: '#1e293b' }}>₹ {userServices?.wallet_balance || '0'}</span>
          <button 
            className="purchase-credits-btn"
            style={{
              background: '#f0fdf4',
              color: '#275c53',
              border: '1.5px solid #275c53',
              borderRadius: 8,
              padding: '8px 20px',
              fontWeight: 600,
              fontSize: 14,
              cursor: 'pointer',
              transition: 'all 0.2s',
            }} 
            onClick={() => setOpen(true)}
          >
            Buy Credits
          </button>
        </div>
      </div>
      <BuyCreditsModal open={open} onClose={() => setOpen(false)} setvisible={setvisible} bilininformation={bilininformation} setBilininformation={setBilininformation}/>
      <style>{`
        @media (max-width: 768px) {
          .purchase-credits-card {
            padding: 16px 16px !important;
            border-radius: 14px !important;
            margin-top: 14px !important;
          }
          .purchase-credits-btn {
            padding: 7px 16px !important;
            font-size: 13.5px !important;
          }
        }
      `}</style>
    </>
  );
} 